var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultLayout',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('v-container',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('CrudAddresses',{ref:"CrudAddresses",attrs:{"default-category":_vm.proofCategory}})],1)],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }